function dropMenu() {

//   if(window.innerWidth <= 991) {
//     const submenuLink = document.querySelector('.nav__link--submenu');
//     const submenu = document.querySelector('.nav__sub-menu');

//     submenuLink.addEventListener('click', (e) => {
//       e.preventDefault();
//       submenu.classList.toggle('nav__submenu--open');
//     });

//     window.addEventListener('click', (e) => {
//       if(e.target != submenuLink) {
//         submenu.classList.remove('nav__submenu--open');
//      }
//     });
//   }

//   window.addEventListener('resize', () => {
//     dropMenu();
//   });


if(window.innerWidth <= 1024){ 
  document.querySelector('.nav__link--submenu').addEventListener('click',(e)=>{
      e.preventDefault();
      // console.log('1')
      document.querySelector('.nav__submenu--sm').classList.toggle('nav__submenu--active');
      document.querySelector('.nav__submenu-link').classList.toggle('nav__submenu-link--active');
    })
  }
}



module.exports =dropMenu;      

